// semeia-disable-reexport
/**
 * Got it from https://stackoverflow.com/a/16187766
 */
export function version1IsLowerThanVersion2(
  version1: string,
  version2: string
): boolean {
  let i = 0;
  let diff = 0;
  const regExStrip0 = /(\.0+)+$/;
  const segmentsA = version1?.replace(regExStrip0, "").split(".");
  const segmentsB = version2?.replace(regExStrip0, "").split(".");
  const l = Math.min(segmentsA?.length, segmentsB?.length);

  for (i = 0; i < l; i++) {
    diff = parseInt(segmentsA[i], 10) - parseInt(segmentsB[i], 10);
    if (diff) {
      return diff < 0;
    }
  }
  return segmentsA?.length - segmentsB?.length < 0;
}
